import React from 'react';

import { Category } from 'src/generics/data';
import { ProductCarousel as ProductCarouselV2 } from 'src/components/carousel-v2/types/product-carousel';

import { useOftenPurchasedWithCarousel } from './use-often-purchased-with-carousel';

// Both fields are consumed indirectly via useOftenPurchasedWithCarousel(props), not destructured directly.
/* eslint-disable react/no-unused-prop-types */
export type OftenPurchasedWithCarouselProps = {
  productId: string;
  category: Category;
};
/* eslint-enable react/no-unused-prop-types */

export function OftenPurchasedWithCarousel(props: OftenPurchasedWithCarouselProps): JSX.Element | null {
  const carouselProps = useOftenPurchasedWithCarousel(props);
  const { products, loading, placement } = carouselProps;
  const label = `Often bought with`;

  if (!loading && !products.length) {
    return null;
  }

  return <ProductCarouselV2 products={products} isLoading={loading} title={label} placement={placement} />;
}
